import './ChatTextBox.css';

interface ChatTextBoxProps {
    value: string;
    onChange: (val: string) => void;
    onSubmit: () => void;
    disabled: boolean;
    placeholder: string;
    error: string | null;
    hint: string;
    onFocus?: () => void;
}

/**
 * ChatTextBox - Pure UI component for text input and submission.
 */
export default function ChatTextBox({
    value,
    onChange,
    onSubmit,
    disabled,
    placeholder,
    error,
    hint,
    onFocus
}: ChatTextBoxProps) {
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
        }
    };

    return (
        <div className="chat-input-section">
            <div className="chat-input-wrapper">
                <input
                    type="text"
                    className="chat-input"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onFocus={onFocus}
                    disabled={disabled}
                />
                <button
                    className={`chat-send-btn ${disabled ? 'loading' : ''} ${!value.trim() ? 'disabled' : ''}`}
                    onClick={onSubmit}
                    disabled={disabled || !value.trim()}
                >
                    {disabled ? (
                        <svg className="spinner" width="18" height="18" viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="32" strokeLinecap="round" />
                        </svg>
                    ) : (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="22" y1="2" x2="11" y2="13" />
                            <polygon points="22 2 15 22 11 13 2 9 22 2" />
                        </svg>
                    )}
                </button>
            </div>
            <p className={`chat-hint ${error ? 'chat-error' : ''}`}>
                {error || hint}
            </p>
        </div>
    );
}
